import type { ComponentPropsWithoutRef } from "react";

import { LoadingIndicator } from "~/components/ui";
import { useTranslation } from "~/i18n";
import { cn } from "~/utils";

interface ReportLoadingStateProps extends ComponentPropsWithoutRef<"div"> {
  message?: string;
}

export function ReportLoadingState({
  className,
  message,
  ...props
}: ReportLoadingStateProps) {
  const { t } = useTranslation();

  return (
    <div
      role="status"
      aria-busy="true"
      className={cn("flex items-start justify-center px-6", className)}
      {...props}
    >
      <div className="flex flex-col items-center gap-3 text-center">
        <LoadingIndicator className="size-6 text-muted/70" />
        <p className="text-sm font-medium leading-6 text-muted">
          {message ?? t("surveyDetail.report.loading")}
        </p>
      </div>
    </div>
  );
}
